'use client'

import { useRouter } from 'next/navigation'

import { Card } from '@/entities/auth'
import { Slot, useDialog } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

import { ResetPasswordForm } from './reset-password-form'

const DIALOG = {
  RESET_PASSWORD_COMPLETED: 'RESET_PASSWORD_COMPLETED',
} as const

type ResetPasswordDialog = keyof typeof DIALOG

type Props = {
  certNum: string
}

export const ResetPassword = ({ certNum }: Props) => {
  const router = useRouter()
  const { isOpen, open, close } = useDialog<ResetPasswordDialog>()

  const closeDialog = (key: ResetPasswordDialog) => () => {
    close(key)
  }

  const handleResetPasswordSuccess = () => {
    open(DIALOG.RESET_PASSWORD_COMPLETED)
  }

  const handleResetPasswordCompleted = () => {
    close(DIALOG.RESET_PASSWORD_COMPLETED)

    router.push('/sign-in')
  }

  return (
    <>
      <Card>
        <Slot name="title">비밀번호 재설정</Slot>
        <Slot name="description">
          신규 비밀번호를 입력해 주세요.
          <br />
          비밀번호는 영문 숫자 조합 6자-15자입니다.
        </Slot>
        <Slot name="children">
          <ResetPasswordForm
            certNum={certNum}
            onSuccess={handleResetPasswordSuccess}
          />
        </Slot>
      </Card>
      <AlertDialog
        isOpen={isOpen(DIALOG.RESET_PASSWORD_COMPLETED)}
        onOpenChange={closeDialog(DIALOG.RESET_PASSWORD_COMPLETED)}
        title="비밀번호가 변경되었습니다"
        content="변경된 비밀번호로 로그인을 진행해 주세요."
        onConfirm={handleResetPasswordCompleted}
        preventOutsideClick
      />
    </>
  )
}
